import axios from 'axios';

export const fetchProducts = (page = 0, size = 20,filterOptions = {}, sortBy , sortDirection) => {

  const defaultParams = {
    page,
    size,
  };

  const sortOptions = {};
  if(sortBy){
    sortOptions['sortBy'] = sortBy;
  }
  if(sortDirection){
    sortOptions['sortDirection'] = sortDirection;
  }

  const params = {...defaultParams, ...filterOptions, ...sortOptions};

  const config = {
    baseURL: `${process.env.STRIPE_SVC_BACKEND_BASE_URL}`,
    params
  };

  return axios.get(`/api/v1/products`, config);
};